import { DEPLOYMENT_NETWORKS } from "../constants/pdm";
import config from "../data/config";
import type { AvailableNetwork } from "../types/pdm.types";
import { fetchWithTimeout } from "../utils/httpClient";

async function parseJson<T>(response: Response): Promise<T> {
  const text = await response.text();
  if (!response.ok) {
    throw new Error(text || response.statusText || "Request failed");
  }
  if (!text) {
    return [] as T;
  }
  return JSON.parse(text) as T;
}

/**
 * GET {PDM_API_BASE_URL}/deployments/available-networks
 * When the base URL is unset, returns a sorted fallback from local constants (mock/dev).
 */
export async function getAvailableNetworks(): Promise<AvailableNetwork[]> {
  const base = config.PDM_API_BASE_URL.replace(/\/$/, "");
  if (!base) {
    return [...DEPLOYMENT_NETWORKS]
      .map((id, index) => ({
        id,
        name: id.charAt(0).toUpperCase() + id.slice(1),
        sort_order: index,
      }))
      .sort((a, b) => a.sort_order - b.sort_order);
  }
  const url = `${base}/deployments/available-networks?isEvm=true`;
  const res = await fetchWithTimeout(url, {
    headers: { Accept: "application/json" },
  });
  const data = await parseJson<AvailableNetwork[]>(res);
  return [...data].sort((a, b) => a.sort_order - b.sort_order);
}
